export const aboutData = {
  brandName: '17c',
  brandFullName: '17c 平台',
  brandIntro: '17c 平台是一个综合性的数字化服务平台，致力于为用户提供便捷、高效、安全的在线服务体验。自上线以来，我们始终坚持以用户需求为导向，持续迭代优化产品功能，打造值得信赖的一站式数字化解决方案。',
  mission: '我们的使命是通过技术创新降低数字化门槛，让每一位用户都能轻松享受数字技术带来的便利与价值。我们坚信，好的产品应当简洁易用，让技术真正服务于人。',
  vision: '成为最受用户信赖的数字化服务平台，持续推动行业进步与创新发展。',

  stats: [
    { label: '服务用户', value: '500,000+' },
    { label: '日均访问', value: '100,000+' },
    { label: '功能模块', value: '30+' },
    { label: '运营年限', value: '5+' },
  ],

  milestones: [
    { year: '2021', title: '平台正式上线', description: '17c 平台完成初期开发与测试，正式面向公众开放服务，推出核心功能模块。' },
    { year: '2022', title: '用户突破 10 万', description: '凭借稳定可靠的服务和良好的用户体验，平台注册用户数突破 10 万大关。' },
    { year: '2023', title: '功能全面升级', description: '新增智能分析引擎、协同办公等多个功能模块，平台服务能力大幅提升。' },
    { year: '2024', title: '安全保障体系建立', description: '完成多层安全防护体系搭建，通过多项国际安全认证，用户数据安全得到全面保障。' },
    { year: '2025', title: '用户突破 50 万', description: '平台注册用户突破 50 万，日均访问量超过 10 万次，行业影响力持续扩大。' },
    { year: '2026', title: '服务全面优化', description: '推出全新界面设计，优化用户体验流程，持续完善功能生态，为用户带来更好的服务。' },
  ],

  reputations: [
    { title: '用户口碑', description: '在各大社区平台和评价渠道中，17c 平台获得了用户的广泛好评，用户满意度持续保持在 95% 以上。' },
    { title: '行业认可', description: '17c 平台凭借出色的产品设计和优质的服务，获得了多项行业荣誉和专业机构认证。' },
    { title: '安全认证', description: '平台已通过多项国际安全标准认证，包括数据安全管理和隐私保护等方面的权威认证。' },
    { title: '媒体报道', description: '17c 平台的创新实践和优秀服务多次被主流科技媒体报道，在业内建立了良好的品牌形象。' },
  ],

  contact: {
    address: '中国上海市浦东新区张江高科技园区',
    email: 'support@17c.com',
    phone: '400-888-8888',
    workingHours: '周一至周五 9:00 - 18:00（法定节假日除外）',
  },
};